import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ABNLookupService } from '../../services/abn-lookup/abn-lookup.service';
import { SuperFundDetails } from '../../interfaces/abn/superFundDetails';

@Component({
  selector: 'app-superannuation[formControl]',
  templateUrl: './superannuation.component.html',
  styleUrls: ['./superannuation.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SuperannuationComponent),
      multi: true,
    },
  ],
})
export class SuperannuationComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;

  @Input() placeholder?: string;

  @ViewChild('search') public searchInput: ElementRef;

  @Output() superFundDetails: EventEmitter<SuperFundDetails | undefined> = new EventEmitter();

  @Output() inputChanged: EventEmitter<boolean> = new EventEmitter();

  hasError: boolean = false;

  constructor(private abnLookupService: ABNLookupService) {}

  searchABN() {
    if (this.formControl.valid) {
      const abnNumber = this.formControl.value;
      this.abnLookupService.searchSuperFundsByABN(abnNumber).subscribe({
        next: (superFundDetails) => {
          if (superFundDetails) {
            this.hasError = false;
            this.superFundDetails.emit(superFundDetails);
          } else {
            this.hasError = true;
            this.superFundDetails.emit(undefined);
          }
        },
        error: (error) => {
          console.log(error);
          this.hasError = true;
        },
      });
    } else {
      console.log('Invalid input');
      this.hasError = true;
    }
  }

  valueChanged() {
    this.inputChanged.emit(true);
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.valueChanged();

    const pastedData = event.clipboardData?.getData('text/plain');

    const strippedValue = pastedData
      ?.replace(/\s+/g, '')
      .replace(/\D/g, '')
      .slice(0, 11);

    this.searchInput.nativeElement.value = strippedValue ?? '';
    this.onChange(strippedValue ?? '');
  }

  onChange = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any): void {
    if (this.formControl && value && value !== this.formControl.value) {
      this.formControl.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
